module.exports = __webpack_public_path__ + "media/images/emblems/Walkringen-coat_of_arms-33d031ebecd3854033f6cef3ae12b444.svg";